import React, { useEffect, useMemo, useState } from 'react';
import { Card, CardContent } from '../../components/ui/card';
import { Input } from '../../components/ui/input';
import api from '../../utils/api';
import { toast } from 'sonner';

const Activity = () => {
  const [operators, setOperators] = useState([]);
  const [query, setQuery] = useState('');
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setLoading(true);
    api.get('/ops/operators/activity')
      .then((res) => setOperators(res.data || []))
      .catch(() => toast.error('Error al cargar actividad'))
      .finally(() => setLoading(false));
  }, []);

  const filtered = useMemo(() => {
    const normalized = query.trim().toLowerCase();
    return operators.filter((entry) => {
      if (!normalized) return true;
      return (
        entry.operator.full_name?.toLowerCase().includes(normalized) ||
        entry.operator.email?.toLowerCase().includes(normalized)
      );
    });
  }, [operators, query]);

  return (
    <div data-testid="global-admin-activity" className="max-w-6xl mx-auto space-y-6">
      <div className="flex flex-wrap items-center justify-between gap-3">
        <div>
          <h1 className="text-2xl font-heading font-semibold">Actividad de operadores</h1>
          <p className="text-muted-foreground">Monitorea asignaciones y tareas en curso</p>
        </div>
        <Input
          value={query}
          onChange={(event) => setQuery(event.target.value)}
          placeholder="Buscar operador"
          className="max-w-sm"
          data-testid="activity-search"
        />
      </div>

      <Card>
        <CardContent className="p-0">
          <div className="grid grid-cols-8 gap-2 px-4 py-3 text-xs uppercase text-muted-foreground border-b">
            <span className="col-span-2">Operador</span>
            <span>Clientes</span>
            <span>Tareas</span>
            <span>Vencidas</span>
            <span>Incumplimientos SLA</span>
            <span>Audit Logs</span>
            <span>Ultima actividad</span>
          </div>
          {loading ? (
            <div className="p-4 text-sm text-muted-foreground">Cargando actividad...</div>
          ) : filtered.length === 0 ? (
            <div className="p-4 text-sm text-muted-foreground">No hay datos</div>
          ) : (
            filtered.map((entry) => (
              <div
                key={entry.operator.id}
                className="grid grid-cols-8 gap-2 px-4 py-3 text-sm border-b last:border-b-0 items-center"
              >
                <div className="col-span-2">
                  <div className="font-medium">{entry.operator.full_name || entry.operator.email}</div>
                  <div className="text-xs text-muted-foreground">{entry.operator.email}</div>
                </div>
                <span>{entry.assigned_tenants}</span>
                <span>{entry.tasks_total}</span>
                <span>{entry.overdue_tasks}</span>
                <span>{entry.sla_breaches}</span>
                <span>{entry.audit_logs_count}</span>
                <div className="text-xs text-muted-foreground">
                  {Object.entries(entry.tasks_by_status || {}).map(([status, count]) => (
                    <div key={status}>
                      {status}: {count}
                    </div>
                  ))}
                </div>
                <span className="text-xs text-muted-foreground">
                  {entry.last_task_at ? entry.last_task_at.split('T')[0] : '-'}
                </span>
              </div>
            ))
          )}
        </CardContent>
      </Card>
    </div>
  );
};

export default Activity;
